"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
const removeNuClick = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("nuclick")) return;
  url.searchParams.delete("nuclick");
  const state = window.history.state ?? {};
  window.history.replaceState(state, "", url.pathname + url.search + url.hash);
};

/**
 * Removes the `nuclick` param from the URL only after GTM has loaded
 * (so GTM can read it on the initial page_view). Falls back to a
 * timeout if GTM is blocked by an ad-blocker or takes too long.
 */
export const NuClickBeacon = () => {
  const $ = _c(5);
  const pathname = usePathname();
  const t0 = useSearchParams();
  let t1;
  if ($[0] !== t0) {
    t1 = t0.toString();
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const search = t1;
  let t2;
  if ($[2] !== pathname || $[3] !== search) {
    t2 = [pathname, search];
    $[2] = pathname;
    $[3] = search;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(_temp, t2);
  return null;
};
function _temp() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("nuclick")) {
    return;
  }
  const gtmScript = document.querySelector("script[src*=\"gtm.js\"], script[src*=\"/securemetric/\"]");
  const timeout = setTimeout(removeNuClick, 5000);
  const onGtmLoad = () => {
    clearTimeout(timeout);
    removeNuClick();
  };
  if (gtmScript?.dataset.ntpc === "GTMScript" || (gtmScript as HTMLScriptElement & {
    complete?: boolean;
  })?.complete) {
    onGtmLoad();
    return;
  }
  if (gtmScript) {
    gtmScript.addEventListener("load", onGtmLoad, {
      once: true
    });
  }
  return () => {
    clearTimeout(timeout);
    gtmScript?.removeEventListener("load", onGtmLoad);
  };
}